import { render, staticRenderFns } from "./TableConfigModal.vue?vue&type=template&id=a561a640&"
import script from "./TableConfigModal.vue?vue&type=script&lang=js&"
export * from "./TableConfigModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports